import { CalendarClock } from "lucide-react";
import { formatDate } from "../lib/dates";

export function LastUpdated({ date, section = false }: { date: string; section?: boolean }) {
  return (
    <div className={section ? "section-updated" : "last-updated"}>
      <CalendarClock size={16} aria-hidden="true" />
      <span>{section ? "Последнее обновление раздела: " : "Обновлено: "}{formatDate(date)}</span>
    </div>
  );
}
